var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout ? _vm.layout : 'NoneLayout',{tag:"component"},[_c('router-view',{key:_vm.$store.state.forceRerender,class:{ 'booking-page' : _vm.currentPath === '/booking/test' }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }